import { http } from './client.js';
import type { RealtimeNotification } from './realtime.js';

export interface NotificationReadResult {
  ok: boolean;
  read?: boolean;
  oaTodoClosed?: boolean;
  oaTodoPending?: boolean;
  oaTodoFailed?: boolean;
  message?: string;
}

export interface NotificationReadAllResult {
  ok: boolean;
  read: number;
  oaTodoClosed: number;
  oaTodoPending: number;
  oaTodoFailed: number;
}

export const notificationApi = {
  async list(limit = 100, opts: { unreadOnly?: boolean } = {}): Promise<RealtimeNotification[]> {
    const res = await http.get<{ items: RealtimeNotification[] }>('/notifications', {
      params: { limit, ...(opts.unreadOnly ? { unreadOnly: true } : {}) },
    });
    return res.data.items;
  },
  async markRead(id: string): Promise<NotificationReadResult> {
    const res = await http.post<NotificationReadResult>(`/notifications/${id}/read`);
    return res.data;
  },
  async markAllRead(): Promise<NotificationReadAllResult> {
    const res = await http.post<NotificationReadAllResult>('/notifications/read-all');
    return res.data;
  },
};
